import React, { useState, useEffect, useContext } from 'react';
import UserContext from "../../../../services/context/userContext";
import generateUnique from '../../../../services/defaultFunctions/generateUnique';
import SupersetsNoSearch from "../../../../components/_workouts/Supersets/SupersetsNoSearch";
import Button from "../../../../components/_default/Button";
import Popup from "../../../../components/_default/Popup";
import DropDown from '../../../_default/DropDown';
import { addWorkoutClient } from "../../../../services/firebase/firestore/saveData";
import { getExercisesAurum, getExercisesCoach, getWorkoutsCoach, getWorkoutsAurum, getWorkoutFromClient, getMealplansCoach, getMealplansAurum, getMealplanFromClient } from '../../../../services/firebase/firestore/getData';
import "./workoutPopup.scss";
import PlansNoSearch from '../../../_mealplans/Plans/PlansNoSearch';


export default function({ onCancel, client_id, time, savePopup, button }) {
    const user = useContext(UserContext);
    const isAdmin = (true);
    const [exercises, setExercises] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [error, setError] = useState(false);
    const [filterName, setFilterName] = useState(false);
    const [supersetName, setSupersetName] = useState(" ");
    const [filter, setFilter] = useState(false);
    const [allWorkouts, setAllWorkouts] = useState(false);
    const [updateData, setUpdateData] = useState(false);
    const [allMealplans, setAllMealPlans] = useState(false);
    const [loading, setLoading] = useState(false);
    const [supersets, setSupersets] = useState([
        {
          exercises: [],
          id: "8796-8897a",
          name: supersetName,
          rest_time_in_minutes: 0,
        },
    ]);
    const [plan, set_plan] = useState([
      {
        food: [
          {
            mealplan_id: "",
            name: "",
            protein: 0,
            fats: 0,
            carbs: 0,
            alcohol: 0,
            fiber: 0,
            calories: 0,
            quantity: 100,
            eaten: false,
            thumbnail: ""
          },
        ],
        id: "8796-8897a",
        name: "",
      },
  ]);

    function addFood(idx) {
      let _plan = [...plan];
      _plan[idx].food.push({
        mealplan_id: generateUnique(1, 9),
        name: "",
        protein: 0,
        fats: 0,
        carbs: 0,
        alcohol: 0,
        fiber: 0,
        calories: 0,
        quantity: 100,
      });
      set_plan(_plan);
  }

    useEffect(() => {
        if(updateData) {
            let _workouts = updateData;

            let data =  {
                exercises: [],
                id: "8796-8897a",
                name: supersetName,
                rest_time_in_minutes: 0,
            };
            let completeData = [];

            let exercises = _workouts.supersets;
            exercises && exercises.forEach(element => {    
              let singleItem = element.exercises;
              singleItem.forEach(item => {
                data.exercises.push(item) 
              });
              data.name = element.name;
              data.id = element.name;
              data.rest_time_in_minutes = parseInt(element.rest_time_in_minutes);

              completeData.push(data);
              // reset data for next time going through loop
              data =   {
                exercises: [],
                id: "8796-8897a",
                name: supersetName,
                rest_time_in_minutes: 0,
              };
            });
            // setsupersets breaks app when there is data already. even though it looks exactly the same as when there is not data
            setSupersets(completeData);
        }else {
          setSupersets([
            {
              exercises: [],
              id: "8796-8897a",
              name: supersetName,
              rest_time_in_minutes: 0,
            },
          ]);     
        }
        getExercisesAurum((aurum_result) => {
          getExercisesCoach(user.id, (coach_result) => {
            let _aurum_result = aurum_result
              ? aurum_result.map((aurum) => {
                  return { ...aurum, from: "aurum" };
                })
              : [];
            let _coach_result = coach_result
              ? coach_result.map((coach) => {
                  return { ...coach, from: user.id };
                })
              : [];
            let result = _aurum_result.concat(_coach_result);
            setExercises(result);
          });
        });
    }, [updateData, user.id]);

    function onDragEnd(result) {
        const { destination, source, type } = result;
        let new_supersets = supersets;
    
        if (!result.destination) {
          return;
        }
        switch (type) {
          case "parent":
            new_supersets = reorder(supersets, source.index, destination.index);
            break;
          case "child":
            new_supersets = reorderChild(supersets, source, destination);
            break;
          default:
            break;
        }
        setSupersets(new_supersets);
      }

      const reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);
    
        return result;
      };
    
      const reorderChild = (list, start, end) => {
        const result = Array.from(list);
        const parent_start_index = result.findIndex((e) => e.id === start.droppableId);
        const parent_end_index = result.findIndex((e) => e.id === end.droppableId);
        const [removed] = result[parent_start_index].exercises.splice(start.index, 1);
        result[parent_end_index].exercises.splice(end.index, 0, removed);
    
        return result;
      };

      function onClickSearch(e, set_idx) {
        let _supersets = [...supersets];
        let _exercise = { ...e };
    
        _exercise.exercise_id = generateUnique(1, 9);
    
        if (!_supersets[set_idx].exercises) {
          _supersets[set_idx].exercises = [];
        }
    
        let new_exercises = {
          exercise_id: generateUnique(1, 9),
          down_pause: 0,
          down: 0,
          sets: 0,
          up_pause: 0,
          kg: 0,
          name: _exercise.name,
          id: _exercise.id,
          starts_with: _exercise.starts_with,
          from: _exercise.from,
          subsitute: [],
          image: _exercise.image,
          reps: 0,
          up: 0,
          rest_time_in_minutes: 0,
        };
    
        _supersets[set_idx].exercises.push(new_exercises);
    
        setSupersets(_supersets);
      }

      function onChange(e, type, exercise_idx, set_idx) {
        let _supersets = [...supersets];
        
        switch (type) {
          case "subsitute_add":
            _supersets[set_idx].exercises[exercise_idx].subsitute.push({ name: e.name, id: e.id, from: e.from, starts_with: e.starts_with });
            break;
          case "subsitute_remove":
            
            _supersets[set_idx].exercises[exercise_idx].subsitute.splice(e, 1);
            break;
    
          default:
            if (exercise_idx !== false) {
              _supersets[set_idx].exercises[exercise_idx][type] = e;
            } else {
              _supersets[set_idx][type] = e;
            }
            break;
        }
        _supersets[set_idx].name = supersetName;

        setSupersets(_supersets);
      }

      function addSet() {
        let _supersets = [...supersets];
        _supersets.push({
          exercises: [],
          id: generateUnique(1, 9),
          name: supersetName,
          rest_time_in_minutes: 0,
        });
        setSupersets(_supersets);
      }

      function onSubmit(duplicate) {
        let _empty_exercises_in_superset = supersets.findIndex((e) => e.exercises.length <= 0);
        
        if (_empty_exercises_in_superset >= 0) {
          setError({ type: "set_exercises", message: "Add at least one exercise.", idx: _empty_exercises_in_superset });
        } else {
          setError(false);
          const _workout = {
            supersets: supersets,
          };

          addWorkoutClient(client_id, _workout, time, (result) => {
            onCancel();
          })
        }
      }

      function removeSet(set_idx) {
        let _supersets = [...supersets];
        switch (showPopup.type) {
          case "set":
            _supersets.splice(set_idx, 1);
            break;
          case "exercise":
            _supersets[showPopup.set_idx].exercises.splice(showPopup.exercise_idx, 1);
            break;
    
          default:
            break;
        }
    
        setSupersets(_supersets);
        setShowPopup(false);
      }

      function removeSetClick(e) {
        let myDiv = document.querySelector('.c-page-workouts');
        myDiv.scrollTo(0, 0);
        setShowPopup({ type: "set", id: e });   
      }
  
      function removeExerciseClick(exercise_idx, set_idx) {
        let myDiv = document.querySelector('.c-page-workouts');
        myDiv.scrollTo(0, 0);
        setShowPopup({ type: "exercise", exercise_idx: exercise_idx, set_idx: set_idx }); 
      }

      useEffect(() => {
        getMealPlan('custom');
        let allMealplans = [];
        getMealplansCoach(user.id, (result) => {
            let mealplans = ["custom"];
            mealplans.push({
              type: 'group', name: 'Coach', items: [
               
              ]
            })
            result && result.forEach(element => {
                mealplans[1].items.push(element.name);
                allMealplans.push(element)
            });
            mealplans.push({
              type: 'group', name: 'Aurum', items: [
               
              ]
            })
            getMealplansAurum((result) => {
              result && result.forEach(element => {
                mealplans[2].items.push(element.name);
                allMealplans.push(element)
              });
            })
            
            setAllMealPlans(allMealplans);
            setFilterName(mealplans);
        })

        getWorkout('custom');
        let allWorkouts = [];
        getWorkoutsCoach(user.id, (result) => {
            // create workout name array for dropdown
            let workouts = ["custom"];
            workouts.push({
                type: 'group', name: 'Coach', items: [ 
                ]
            });
            result && result.forEach(element => {
                workouts[1].items.push(element.name);
                allWorkouts.push(element);
            });
            workouts.push({
                type: 'group', name: 'Aurum', items: [   
                ]
            })
            getWorkoutsAurum((result) => {
                result && result.forEach(element => {
                  workouts[2].items.push(element.name);
                  allWorkouts.push(element);
                });
            })
            setAllWorkouts(allWorkouts);
            setFilterName(workouts);
        })
    }, [user]);

    function getWorkout(e) {
        if(e != "custom") {
          let workout = allWorkouts.find(x => x.name === e)
          setUpdateData(workout);
        }else {
          // check if there is one in db for user
          getWorkoutFromClient(client_id,time, (result) => {
            if(result) {
              setUpdateData(result.content);
            }else {
              setUpdateData(false);
            }
          })
        }
    }

    function getPreviousValues(e) {
      // get prev workouts value
      // set prev workouts value
    }

    function getMealPlan(e) {
      if(e != "custom") {
        let meal = allMealplans.find(x => x.name === e)
        setUpdateData(meal);
      }else {
        // check if there is one in db for user
        getMealplanFromClient(client_id,time, (result) => {
          if(result) {
            setUpdateData(result);
          }else {
            setUpdateData(false);
          }
        })
      }
    }

    return(
        <>            
            <div className="c-page-wrapper c-page-wrapper-workout">
              <div className="c-page-main c-define-page c-page-workouts">
                <div className="c-popup-dropdown-container c-popup-dropdown-container-workout">
                  <h3>Select workout to autofill</h3>
                  <DropDown options={filterName? filterName : []} value={filter} onChange={(e) => {setFilter(e); getWorkout(e)}} />
                </div>

                <SupersetsNoSearch supersetName={supersetName} previousValues={(e) => {getPreviousValues(e)}} setName={e => setSupersetName(e.target.value)} isPersonal={true} isAdmin={isAdmin} exercises={exercises} supersets={supersets} setSupersets={setSupersets} onDragEnd={onDragEnd} removeSet={(e) =>removeSetClick(e)} removeExercise={(exercise_idx, set_idx) => removeExerciseClick(exercise_idx, set_idx)} onClickSearch={(e, set_idx) => onClickSearch(e, set_idx)} onChange={(e, type, exercise_idx, set_idx) => onChange(e, type, exercise_idx, set_idx)} error={error} />

                <div className="c-button-collection c-button-collection-largePopup">
                  {/* <Button text="Save" color="#fff" backgroundColor="#00BDA5" onSubmit={() => onSubmit(false)} />
                  <button className="c-cancel-btn" onClick={() => onCancel()}>
                      Cancel
                  </button> */}
                </div>
              </div>
            </div>

            <div className="c-page-wrapper c-page-wrapper-mealplan">
            <div className="c-popup-dropdown-container">
                <h3 className="c-mealplan-popdata-titel">Select mealplan to autofill</h3>
                <DropDown options={filterName? filterName : []} value={filter} onChange={(e) => {setFilter(e); getMealPlan(e)}} />
            </div>
            <div className="c-page-main c-define-page c-page-plans">    
                <PlansNoSearch isAdmin={isAdmin} addFood={(idx) => addFood(idx)} plan={plan} set_plan={set_plan} onDragEnd={onDragEnd} removeSet={(e) => removeSetClick(e)} removeExercise={(mealplan_idx, set_idx) => removeExerciseClick(mealplan_idx, set_idx)} onChange={(e, type, food_idx, plan_idx) => onChange(e, type, food_idx, plan_idx)} error={error} />
                {/* <button className="c-add-content-btn" style={{backgroundColor: "rgb(92, 171, 183)", marginBottom: '20px'}}>
                    Chage date
                </button> */}
                <div className="c-button-collection c-button-collection-largePopup">
                  <Button text={button} color="#fff" backgroundColor="#00BDA5" className={`c-close-btn ${savePopup ? "--save" : ""}`} onSubmit={() => onSubmit(false)} loading={loading} />
                  <button className="c-cancel-btn" onClick={() => onCancel()}>
                    Cancel
                  </button>
                </div>
            </div>
        </div>

            {showPopup && (
            <Popup
              title={"Remove item"}
              button="Remove"
              deletePopup={true}
              description={"Are you sure you want to remove this item? This can not be undone."}
              onAction={() => removeSet(showPopup.id)}
              onCancel={() => {
                setShowPopup(false);
              }}
            />
          )}
        </>
    );
}